<!--Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.-->
<div class="breadcrumbs-container px-3 md:px-6"
     *ngIf="isVisible">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb-list">
      <li class="breadcrumb-item"
          *ngFor="let crumb of breadcrumbs; let last = last">
        <!-- Link for non-last items -->
        <a *ngIf="!last"
           [routerLink]="crumb.url"
           class="breadcrumb-link">
          <i class="pi pi-home"
             *ngIf="crumb.label === 'Home'"></i>
          <span *ngIf="crumb.label !== 'Home'">{{ crumb.label }}</span>
        </a>

        <!-- Text for last item (Current Page) -->
        <span *ngIf="last"
              class="breadcrumb-current"
              aria-current="page">
          {{ crumb.label }}
        </span>

        <!-- Separator -->
        <i *ngIf="!last"
           class="pi pi-angle-right separator"></i>
      </li>
    </ol>
  </nav>
</div>
